import React from 'react';
import { Button } from '../ui/button';
import ValuarePlanta from '../ValuarePlanta';

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

export const HeroSection = () => (
  <section className="valuare-hero vjr-hero-home" data-testid="hero-section">
    <ValuarePlanta />
    <div className="vjr-hero-veil" aria-hidden="true" />
    <img
      src="https://customer-assets.emergentagent.com/job_valuare-jr-preview/artifacts/ld82pk4p_upscalemedia-transformed.png"
      alt=""
      aria-hidden="true"
      className="vjr-hero-watermark"
      data-testid="hero-watermark"
    />
    <div className="valuare-hero-content">
      <div className="valuare-hero-badge" style={{ marginBottom: '30px' }}>
        <span className="valuare-badge">CMVM PAI/2025/0020</span>
        <span className="valuare-badge">ANAI 1267</span>
      </div>
      <h1 className="valuare-hero-title">
        Avaliações Imobiliárias<br />
        <em>Certificadas</em> CMVM
      </h1>
      <p className="valuare-hero-subtitle">Perito Avaliador Certificado · Normas EVS / TEGoVA</p>
      <div className="valuare-hero-cta">
        <Button
          onClick={() => scrollTo('contacto')}
          className="valuare-btn-primary"
          data-testid="hero-cta-solicitar"
        >
          Solicitar Avaliação
        </Button>
        <Button
          onClick={() => scrollTo('servicos')}
          variant="outline"
          className="valuare-btn-outline"
          data-testid="hero-cta-servicos"
        >
          Ver Serviços
        </Button>
      </div>
    </div>
  </section>
);
